import { AxiosPromise } from "axios";
import { GenericServices } from "./generic.services";
import Uri from '../common/uri/common-uri.constants';
import { LOOKUP_TYPEOFPROPERTY, LOOKUP_COUTRY, LOOKUP_SITE, LOOKUP_PERSON_FUNCTION, LOOKUP_COMPANY_DEPARTMENT, LOOKUP_OBJECTGOAL, LOOKUP_CITY, LOOKUP_SINCE_DATE } from '../common/lookup-types.constant';
import { ApiResponse } from "../models/app-configuration";
import { IAppointmentStatus } from '../models/agenda/appointment-status.model';
import { IAppointmentTypeParameterModel } from '../models/agenda/appointment-type-parameter.model';
import { IAppointmentStatusParameterModel } from '../models/agenda/appointment-status-parameter.model';
import { IAppointmentTypeListing } from "../models/agenda";
export class LookupServices extends GenericServices {
    select<TValue, TResult>(params: TValue, path?: string, encodeUri: boolean = true): AxiosPromise<TResult> {
        return this.executeSelecting(params, path, encodeUri);
    }

    getListTypesOfProperty() {
        const reqUrl = Uri.getLookup + '?lang=all';
        return super.executeSelectBy({ type: LOOKUP_TYPEOFPROPERTY }, reqUrl)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.TypeOfProperty);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }
    getListOfPurposes() {
        return super.executeSelecting(undefined, Uri.purposes)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.items);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }
    getListOfGoals() {
        return super.executeSelectBy({ type: LOOKUP_OBJECTGOAL }, Uri.getLookup)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.ObjectGoal);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }
    getListOfOrientations() {
        return super.executeSelecting(undefined, Uri.getLookup.replace(':type', 'RearOrientation'))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data['RearOrientation']);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }
    getListOfStatuses() {
        return super.executeSelecting(undefined, Uri.demandStatus)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.items);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }
    
    getListOfSites() {
        return super.executeSelecting(undefined, Uri.getLookup.replace(':type', LOOKUP_SITE))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.Site || []);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    getListOfSinceDate() {
        return super.executeSelecting(undefined, Uri.lookUpData.replace(':type', LOOKUP_SINCE_DATE))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.SinceDate || []);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    getListOfPersonFunctions() {
        return super.executeSelecting(undefined, Uri.getLookup.replace(':type', LOOKUP_PERSON_FUNCTION))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.PersonFunction || []);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    getListOfCompanyDepartments() {
        return super.executeSelecting(undefined, Uri.getLookup.replace(':type', LOOKUP_COMPANY_DEPARTMENT))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.CompanyDepartment || []);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    getListOfEmailsByPropertyIds(propertyIds: string) {
        if (propertyIds.length <= 0)
            return Promise.reject('List of property ids must be more than 0');
        let url = Uri.getLookupEmailByPropertyIds.replace(':propertyIds', propertyIds);
        return super.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data || []);
                } else return Promise.reject(response);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    getListOfAppointmentTypes(params: IAppointmentTypeParameterModel): AxiosPromise<IAppointmentTypeListing[]> {
        return super.executeSelecting(params, Uri.agendaType);
    }
    getListOfAppointmentStatus(params: IAppointmentStatusParameterModel): AxiosPromise<IAppointmentStatus[]> {
        return super.executeSelecting(params, Uri.agendaStatus);
    }
    getAppointmentConfig() {
        return super.executeSelecting(undefined, Uri.getAppointmentconfig)
            .then((response: ApiResponse) => Promise.resolve(response))
            .catch(error => Promise.reject(error))
    }
    constructor() {
        super();
    }

    searchCountries(queryString) {
        if (!queryString)
            return Promise.resolve([]);
        let url = Uri.getLookup.replace(':type', LOOKUP_COUTRY);
        url = url + "?SearchText=" + queryString;
        return super.executeSelecting(undefined, url, false)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.Country || []);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    searchCities(queryString, countryId) {
        if (!queryString)
            return Promise.resolve([]);
        let url = Uri.getLookup.replace(':type', LOOKUP_CITY);
        url = url + "?SearchText=" + queryString;
        if (countryId)
            url = url + "&countryId=" + countryId;
        return super.executeSelecting(undefined, url, false)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.City || []);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    getDuration(query: string) {
        return super.executeSelecting(undefined, Uri.getLookup.replace(':type', query)).then((response: ApiResponse) => {
            if (!response.isSuccess) Promise.reject(response);
            return Promise.resolve(response.data.DurationTask || []);
        }).catch((errors) => {
            console.log(errors);
        });
    }

    getTaskGroup(type: string) {
        return super.executeSelecting(undefined, Uri.lookUpData.replace(':type', type)).then((response: ApiResponse) => {
            if (!response.isSuccess) Promise.reject(response);
            return Promise.resolve(response.data.TaskGroup || []);
        }).catch((error) => {
            return Promise.reject(error);
        });
    }

    getListCandidate(type: string) {
        return super.executeSelecting(undefined, Uri.lookUpData.replace(':type', type)).then((response: ApiResponse) => {
            if (!response.isSuccess) Promise.reject(response);
            return Promise.resolve(response?.data?.Candidate || []);
        }).catch((error) => {
            return Promise.reject(error);
        });
    }
}
